import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { USERS_OPERATIONS_ROUTE_PATHS } from './config';

export const USERS_OPERATIONS_ROUTES: TApplicationRoute[] = [
  {
    id: 'users-operations',
    path: USERS_OPERATIONS_ROUTE_PATHS.usersOperations,
    component: lazy(() => import('./pages/users-operations-page')),
    layout: 'default',
    permissions: { scopes: ['users-operations'] },
    menu: {
      title: 'pages.usersOperations.title',
    },
  },
];
